<wa-card>
  <div class="wa-stack">
    <div><h5>{{ exam().module.name }}</h5></div>
    <div class="wa-split wa-align-items-start wa-gap-xl">
      <div class="wa-stack">
        <div>{{ exam().module.code }}
          @if (exam().has_repetition) {
            <wa-badge variant="neutral" appearance="filled outlined" pill>
              <wa-icon name="recycle" label="retake exam"></wa-icon>
            </wa-badge>
          }
        </div>
        <div>Examiner (tbd)</div>
        <div>Organizer (tbd)</div>
      </div>
      <div class="wa-stack">
        <div class="wa-cluster">
          <wa-icon variant="solid" name="calendar"></wa-icon>
          <span>{{ exam().main_exam.begin | date: dateFormat }}, {{ exam().main_exam.begin | date: timeFormat }}
            -{{ exam().main_exam.end | date: timeFormat }}</span>
        </div>
        @if (exam().has_repetition) {
        <div class="wa-cluster">
          <wa-icon variant="solid" name="calendar"></wa-icon>
          <span>{{ exam().retake_exam!.begin | date: dateFormat }}, {{ exam().retake_exam!.begin | date: timeFormat }}
            -{{ exam().retake_exam!.end | date: timeFormat }}</span>
        </div>
        } @else {
          <span> — </span>
        }
        <div class="wa-cluster">
          <wa-icon variant="solid" name="location-dot"></wa-icon>
          @if (!locationNames.size) {
            <span>???</span>
          } @else {
          @for (locationName of locationNames; track locationName) {
            <span>{{ locationName }}</span>
            @if (!$last) {
              <span>, </span>
            }
          }
        }
        </div>
        <div class="wa-cluster">
          <wa-icon variant="regular" name="buildings"></wa-icon>
          <span>{{ exam().rooms.length }}</span>
        </div>
        <div class="wa-cluster">
          <wa-icon variant="solid" name="people"></wa-icon>
          <span>{{ (exam().main_exam.participants || 0) + (exam().retake_exam?.participants || 0) }}</span>
        </div>
      </div>
    </div>
  </div>
</wa-card>
